var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizeMachinesListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262,
    height: 198,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PrizeMachinesListIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 481",
    fill: "none",
    d: "M0 0h262v198H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PrizeMachinesListIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 471",
    fill: "none",
    d: "M0 0h49.141v49.207H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "PrizeMachinesListIcon",
    clipPath: "url(#PrizeMachinesListIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 470",
    fill: "#040000",
    d: "M89.651 25.338h3.703v140.031h-3.703z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 817",
    d: "M17.447 165.366h74.052v-53H17.447zm61.471-19.364a1.484 1.484 0 01-1.484 1.486H32.5a1.49 1.49 0 01-1.484-1.486v-20.4a1.489 1.489 0 011.484-1.485h44.935a1.483 1.483 0 011.484 1.485z",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 818",
    d: "M143.89 147.489h-37.956a1.482 1.482 0 01-1.475-1.486v-20.4a1.48 1.48 0 011.475-1.485h29.768a46.652 46.652 0 01-.182-4.183 49.685 49.685 0 01.477-6.87 9.21 9.21 0 01.1-.7H91.689v53.001h73.623a49.526 49.526 0 01-21.421-17.878",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 819",
    d: "M165.561 27.766H17.444v-9.144a1.649 1.649 0 011.648-1.65h144.821a1.65 1.65 0 011.648 1.65z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 820",
    d: "M17.53 26.069v86.987h118.468c.025-.231.058-.47.1-.7a45.58 45.58 0 01.56-3.012H21.238V29.777h140.715v46.332q1.806-.965 3.7-1.765V26.069zm72.123 3.7h41.163v-2H89.653zm3.7 79.571v3.012h31.934c.124-1.016.272-2.022.453-3.012zm-3.7-79.563h41.163v-2.008H89.653zm3.7 79.571v3.012h31.934c.124-1.016.272-2.022.453-3.012zm0 0v3.012h31.934c.124-1.016.272-2.022.453-3.012zm-3.7-79.571h41.163v-2.008H89.653zm3.7 79.571v3.012h31.934c.124-1.016.272-2.022.453-3.012zm-3.7-79.571h41.163v-2.008H89.653z",
    fill: "#231815"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 437",
    transform: "translate(109.755 29.051)",
    clipPath: "url(#PrizeMachinesListIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 821",
    d: "M8.252 29.666l7.947 13.784-.426.244-5.111-2.385-6.566-11.387.676-2.555 9.036-5.224 4.048-2.337c-.018.144-.032.291-.043.439s-.016.295-.016.445a6.867 6.867 0 00.076 1.007c.019.131.044.26.07.389l.043.193c.03.127.063.252.1.377.019.064.04.125.059.186a6.614 6.614 0 00.371.888l-3.968 2.294z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 822",
    d: "M25.665 19.601l-.78.449-.318.185-.811.469-.54.312-.059.035-2.58 1.492a4.408 4.408 0 01-.408-1.853 4.308 4.308 0 01.3-1.6c.055-.139.116-.275.182-.4a4.452 4.452 0 01.534-.808l1.911-1.105.119-.068.59-.34.761 1.328.426.738.445.771z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 823",
    d: "M28.97 20.69a4.384 4.384 0 01-.412 1.855l-2.581-1.495-.059-.035-.54-.312-.813-.469-.316-.184-.78-.45.229-.4.444-.771.424-.738.77-1.329.584.338.119.068 1.914 1.107a4.432 4.432 0 01.535.809 3.643 3.643 0 01.182.4 4.364 4.364 0 01.3 1.6",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 824",
    d: "M45.042 29.922l-6.566 11.387-5.111 2.384-.426-.244 7.947-13.784-6.3-3.637-3.969-2.293a6.6 6.6 0 00.39-.935 4.91 4.91 0 00.087-.285 6.728 6.728 0 00.25-1.821 6.078 6.078 0 00-.066-.888l4.054 2.345 9.029 5.22z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 825",
    d: "M28.975 20.69a4.384 4.384 0 01-.412 1.855.241.241 0 01-.016.037c0 .008-.007.014-.008.022a4.406 4.406 0 01-7.937 0c0-.008-.006-.014-.008-.022a.273.273 0 01-.016-.039 4.424 4.424 0 01-.407-1.854 4.311 4.311 0 01.3-1.6c.055-.139.117-.275.182-.4a4.475 4.475 0 01.535-.809 4.337 4.337 0 011.911-1.334 2.644 2.644 0 01.26-.084l.084-.025a4.306 4.306 0 012.254 0c.029.008.055.014.087.025.087.024.174.051.258.082a4.35 4.35 0 011.914 1.337 4.433 4.433 0 01.535.808 3.644 3.644 0 01.182.4 4.364 4.364 0 01.3 1.6",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 826",
    d: "M17.797 20.882v.029-.029z",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 827",
    d: "M17.797 20.882v.029-.029z",
    fill: "none",
    stroke: "#060001",
    strokeMiterlimit: 10,
    strokeWidth: 0.657
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 828",
    d: "M26.078 11.152a2.417 2.417 0 00-.124-.017 10.947 10.947 0 00-2.768 0c-.044 0-.089.012-.127.017a11.079 11.079 0 00-9.523 10.946v.046a11.035 11.035 0 00.741 3.931l.019.054a11.1 11.1 0 002.853 4.128l.077.07h14.689l.077-.07a11.059 11.059 0 002.846-4.129l.017-.05a10.85 10.85 0 00.749-3.931v-.05a11.081 11.081 0 00-9.527-10.946m-8.012 9.538c0-.135 0-.274.016-.427s.024-.285.041-.422v-.019a6.537 6.537 0 015.04-5.494l.1-.023a6.807 6.807 0 011.3-.13 6.668 6.668 0 011.314.133l.1.022a6.528 6.528 0 015.033 5.512 5.777 5.777 0 01.063.848 6.489 6.489 0 01-.24 1.747c-.026.091-.053.18-.084.272a6.4 6.4 0 01-.373.9l-.03.06a6.5 6.5 0 01-11.562 0l-.03-.06a6.292 6.292 0 01-.355-.85c-.02-.059-.04-.12-.057-.178-.035-.12-.069-.241-.1-.361l-.042-.188a7.52 7.52 0 01-.067-.375c-.012-.079-.021-.158-.03-.234l-.019-.193c0-.035-.007-.07-.009-.087v-.088l-.006-.142a.188.188 0 000-.036v-.185",
    fill: "#060001"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 472",
    fill: "#231815",
    d: "M130.815 26.773h7.02v14.059h-7.02z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 438",
    transform: "translate(24.11 29.051)",
    clipPath: "url(#PrizeMachinesListIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 829",
    d: "M8.251 29.666l7.947 13.784-.426.244-5.11-2.385-6.568-11.386.676-2.555 9.036-5.224 4.048-2.337c-.018.144-.032.291-.043.439s-.016.295-.016.445a6.866 6.866 0 00.076 1.007c.019.131.044.26.07.389l.043.193c.03.127.063.252.1.377.019.064.04.125.059.186a6.61 6.61 0 00.371.888l-3.968 2.294z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 830",
    d: "M25.665 19.601l-.78.449-.318.185-.811.469-.54.312-.059.035-2.58 1.492a4.408 4.408 0 01-.408-1.853 4.309 4.309 0 01.3-1.6c.055-.139.116-.275.182-.4a4.451 4.451 0 01.534-.808l1.911-1.105.119-.068.59-.34.761 1.328.426.738.445.771z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 831",
    d: "M28.972 20.69a4.385 4.385 0 01-.412 1.855l-2.581-1.495-.058-.034-.54-.312-.813-.469-.316-.184-.78-.45.229-.4.444-.771.424-.738.77-1.329.584.338.119.068 1.914 1.107a4.433 4.433 0 01.535.808 3.646 3.646 0 01.182.4 4.363 4.363 0 01.3 1.6",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 832",
    d: "M45.045 29.922L38.479 41.31l-5.111 2.384-.426-.244 7.951-13.784-6.3-3.637-3.969-2.294a6.593 6.593 0 00.39-.935c.032-.095.061-.189.088-.285a6.761 6.761 0 00.25-1.821 6.077 6.077 0 00-.066-.888l4.054 2.345 9.029 5.22z",
    fill: "#060001"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 833",
    d: "M28.972 20.69a4.385 4.385 0 01-.412 1.855.239.239 0 01-.016.037c0 .008-.007.014-.008.022a4.406 4.406 0 01-7.937 0c0-.008-.006-.014-.008-.022a.274.274 0 01-.016-.039 4.424 4.424 0 01-.407-1.854 4.311 4.311 0 01.3-1.6c.055-.139.117-.275.182-.4a4.476 4.476 0 01.535-.808 4.337 4.337 0 011.911-1.334 2.643 2.643 0 01.26-.084l.084-.025a4.306 4.306 0 012.254 0c.029.008.055.014.087.025.087.024.174.051.258.082a4.35 4.35 0 011.914 1.337 4.433 4.433 0 01.535.808 3.647 3.647 0 01.182.4 4.363 4.363 0 01.3 1.6",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 834",
    d: "M17.796 20.882v.029-.029z",
    fill: "#070102"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 835",
    d: "M17.796 20.882v.029-.029z",
    fill: "none",
    stroke: "#060001",
    strokeMiterlimit: 10,
    strokeWidth: 0.657
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 836",
    d: "M26.078 11.152a2.417 2.417 0 00-.124-.017 10.948 10.948 0 00-2.768 0c-.044 0-.089.012-.127.017a11.079 11.079 0 00-9.523 10.946v.046a11.035 11.035 0 00.741 3.931l.019.054a11.1 11.1 0 002.848 4.129l.077.07h14.694l.077-.07a11.059 11.059 0 002.846-4.129l.017-.05a10.849 10.849 0 00.749-3.935v-.05a11.081 11.081 0 00-9.527-10.946m-8.012 9.538c0-.135 0-.274.016-.427s.024-.285.041-.422v-.019a6.537 6.537 0 015.04-5.495l.1-.023a6.806 6.806 0 011.3-.13 6.667 6.667 0 011.314.133l.1.022a6.528 6.528 0 015.036 5.519 5.776 5.776 0 01.063.848 6.488 6.488 0 01-.24 1.747c-.026.091-.053.18-.084.272a6.4 6.4 0 01-.373.9l-.03.06a6.5 6.5 0 01-11.562 0l-.03-.06a6.294 6.294 0 01-.355-.85c-.02-.059-.04-.12-.057-.178-.035-.12-.069-.241-.1-.361l-.042-.188a7.52 7.52 0 01-.067-.375c-.012-.079-.021-.158-.03-.234l-.019-.193c0-.035-.007-.07-.009-.087v-.088l-.006-.142a.189.189 0 000-.036v-.185",
    fill: "#060001"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 474",
    fill: "#231815",
    d: "M45.169 26.773h7.02v14.059h-7.02z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 837",
    d: "M125.74 109.348c-.182.99-.33 2-.454 3.011h10.81c.157-1.015.338-2.021.561-3.011a49.549 49.549 0 0125.293-33.239V64.27a60.268 60.268 0 00-36.21 45.078m-.792 14.768a59.8 59.8 0 006.517 23.372h12.424a49.07 49.07 0 01-8.189-23.372zm.792-14.768c-.182.99-.33 2-.454 3.011h10.81c.157-1.015.338-2.021.561-3.011a49.549 49.549 0 0125.293-33.239V64.27a60.268 60.268 0 00-36.21 45.078m59.213-49.64a59.766 59.766 0 00-19.3 3.176q-1.877.631-3.7 1.386a60.268 60.268 0 00-36.21 45.078c-.182.99-.33 2-.454 3.011-.032.231-.066.462-.082.7a58.915 58.915 0 00-.4 6.872c0 1.411.05 2.8.14 4.183a60.145 60.145 0 1060-64.408m0 109.725a49.455 49.455 0 01-49.252-45.316 46.69 46.69 0 01-.182-4.184 49.694 49.694 0 01.477-6.869c.025-.235.059-.474.1-.7.157-1.015.338-2.021.561-3.011a49.549 49.549 0 0125.293-33.239q1.806-.965 3.7-1.765a49.492 49.492 0 1119.3 95.089m-59.213-60.085c-.182.99-.33 2-.454 3.011h10.81c.157-1.015.338-2.021.561-3.011a49.55 49.55 0 0125.293-33.239V64.27a60.268 60.268 0 00-36.21 45.078",
    fill: "#231815"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 475",
    fill: "#231815",
    d: "M162.717 100.068h8.717v8.729h-8.717z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 476",
    fill: "#231815",
    d: "M162.717 116.914h8.717v8.737h-8.717z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 477",
    fill: "#231815",
    d: "M162.717 133.761h8.717v8.737h-8.717z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 440",
    fill: "#231815"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 838",
    d: "M204.521 138.125a2.108 2.108 0 01-2.1 2.113H178.91a2.108 2.108 0 010-4.217h23.51a2.1 2.1 0 012.1 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 839",
    d: "M204.521 121.279a2.1 2.1 0 01-2.1 2.113H178.91a2.108 2.108 0 010-4.217h23.51a2.1 2.1 0 012.1 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 840",
    d: "M205.791 104.44a2.114 2.114 0 01-2.11 2.1h-23.514a2.108 2.108 0 010-4.217h23.514a2.115 2.115 0 012.11 2.112"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 841",
    d: "M185.366 68.759a51.563 51.563 0 1051.494 51.562 51.528 51.528 0 00-51.494-51.562m32.958 81.4a3.155 3.155 0 01-3.146 3.16h-59.61a3.164 3.164 0 01-3.156-3.16V90.481a3.158 3.158 0 013.156-3.16h59.61a3.156 3.156 0 013.146 3.16z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 478",
    d: "M162.717 100.068h8.717v8.729h-8.717z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 479",
    d: "M162.717 116.914h8.717v8.737h-8.717z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 480",
    d: "M162.717 133.761h8.717v8.737h-8.717z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 842",
    d: "M204.521 138.125a2.108 2.108 0 01-2.1 2.113H178.91a2.108 2.108 0 010-4.217h23.51a2.1 2.1 0 012.1 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 843",
    d: "M204.521 121.279a2.1 2.1 0 01-2.1 2.113H178.91a2.108 2.108 0 010-4.217h23.51a2.1 2.1 0 012.1 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 844",
    d: "M205.791 104.44a2.114 2.114 0 01-2.11 2.1h-23.514a2.108 2.108 0 010-4.217h23.514a2.115 2.115 0 012.11 2.112"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeMachinesListIcon);
export default __webpack_public_path__ + "static/media/PrizeMachinesListIcon.975aa41ef6e7bef4.svg";
export { ForwardRef as ReactComponent };